import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        context: '=',
        sites: '=',
        courseVersions: '=',
        saveErrors: '<'
    },
    template: `
    <form class="form apg-general-form" ng-submit="vm.save()">
        <form-wrapper form="vm.form">
            <alert-error ng-if="vm.form.errors.status">
                <span ng-bind-html="vm.form.errors.status"></span>
            </alert-error>
            <alert-error ng-if="vm.form.errors.trainings">
                <span>{{ vm.form.errors.trainings }}</span>
            </alert-error>
            <form-row error="vm.form.errors.name">
                <label class="label">
                    {{ 'planningGroup.Name' | translate }}
                    <span class="apg-label-marks">* <tooltip html="vm.tooltipTexts.name" /></span>
                </label>
                <div class="items">
                    <input type="text" class="form-control"
                        ng-model="vm.form.model.name"
                        ng-readOnly="vm.isReadOnly"
                        ng-disabled="vm.isReadOnly"
                    >
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.siteIds">
                <label class="label">{{ 'planningGroup.Site' | translate }} *</label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.siteMultiFilter.options"
                        selected-model="vm.siteMultiFilter.models"
                        extra-settings="vm.siteMultiFilter.settings"
                        events="vm.siteMultiFilter.events"
                        disabled="vm.isReadOnly || vm.disableSiteSelect"
                        translation-texts="vm.siteMultiFilter.translations"
                    ></div>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row ng-if="vm.isAllSitesSelected() && vm.TokenService.isTrainingCompany()" error="vm.form.errors.excludeExternalSites">
                <label class="label">{{ 'site.Exclude external sites' | translate }}</label>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label>
                                <input
                                    ng-disabled="vm.isReadOnly"
                                    ng-model="vm.form.model.excludeExternalSites"
                                    type="checkbox"
                                > {{ 'general.Yes' | translate }}
                            </label>
                        </li>
                    </ul>
                </div>
            </form-row>
            <form-row error="vm.form.errors.courseVersionId">
                <label class="label">{{ 'planningGroup.Version' | translate }} *</label>
                <div class="items">
                    <select class="form-control"
                        ng-model="vm.form.model.courseVersionId"
                        ng-readOnly="vm.isReadOnly"
                        ng-disabled="vm.isReadOnly"
                        ng-options="version.id as version.name for version in vm.courseVersions"
                    />
                    </select>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.interval || vm.form.errors.intervalType">
                <label class="label">
                    {{ 'planningGroup.Personal deadline value' | translate }} *
                    <small>{{ 'planningGroup.personal_deadline_value_field_notice' | translate }}</small>
                </label>
                <div class="items">
                    <div class="apg-unit-field">
                        <input class="form-control small02"
                            type="number"
                            ng-model="vm.form.model.interval"
                            ng-readOnly="vm.isReadOnly"
                            ng-disabled="vm.isReadOnly"
                        />
                        <select class="form-control small02"
                                ng-model="vm.intervalTypeObj"
                                ng-disabled="vm.isReadOnly"
                                ng-change="vm.form.model.intervalType = vm.intervalTypeObj && vm.intervalTypeObj.key"
                                ng-options="opt as opt.label for opt in vm.intervalTypeOptions track by opt.key">
                        </select>
                    </div>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.assignmentTimeBeforeDeadline || vm.form.errors.assignmentTimeBeforeDeadlineType">
                <label class="label">
                    {{ 'planningGroup.Course assignment time' | translate }}
                    <span class="apg-label-marks">* <tooltip html="vm.tooltipTexts.assignmentTimeBeforeDeadline" /></span>
                </label>
                <div class="items">
                    <div class="apg-unit-field">
                        <input class="form-control small02"
                            type="number"
                            ng-model="vm.form.model.assignmentTimeBeforeDeadline"
                            ng-readOnly="vm.isAssignmentTimeBeforeDeadlineReadOnly"
                            ng-disabled="vm.isAssignmentTimeBeforeDeadlineReadOnly"
                            min="{{ vm.minAssignmentTimeBeforeDeadline }}"
                            max="{{ vm.maxAssignmentTimeBeforeDeadline }}"
                            required
                        />
                        <select class="form-control small02"
                                ng-model="vm.assignmentBeforeTypeObj"
                                ng-disabled="vm.isAssignmentTimeBeforeDeadlineReadOnly"
                                ng-change="vm.form.model.assignmentTimeBeforeDeadlineType = vm.assignmentBeforeTypeObj && vm.assignmentBeforeTypeObj.key"
                                ng-options="opt as opt.label for opt in vm.intervalTypeOptions track by opt.key">
                        </select>
                        <span class="text">{{ 'planningGroup.before deadline' | translate }}</span>
                    </div>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <hr>
            <h3>{{ 'planningGroup.After initial deadline has passed' | translate }}</h3>
            <form-row error="vm.form.errors.recurringTrainingDeadline || vm.form.errors.recurringTrainingDeadlineType">
                <label class="label">
                    {{ 'planningGroup.Recurring training deadline' | translate }}
                    <span class="apg-label-marks">* <tooltip html="vm.tooltipTexts.recurringTrainingDeadline" /></span>
                </label>
                <div class="items">
                    <div class="apg-unit-field">
                        <input class="form-control small02"
                            type="number"
                            ng-model="vm.form.model.recurringTrainingDeadline"
                            ng-readOnly="vm.isRecurringTrainingDeadlineReadOnly"
                            ng-disabled="vm.isRecurringTrainingDeadlineReadOnly"
                            min="{{ vm.rinRecurringTrainingDeadline }}"
                            max="{{ vm.raxRecurringTrainingDeadline }}"
                            required
                        />
                        <select class="form-control small02"
                                ng-model="vm.recurringTypeObj"
                                ng-disabled="vm.isRecurringTrainingDeadlineReadOnly"
                                ng-change="vm.form.model.recurringTrainingDeadlineType = vm.recurringTypeObj && vm.recurringTypeObj.key"
                                ng-options="opt as opt.label for opt in vm.intervalTypeOptions track by opt.key">
                        </select>
                    </div>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    </form>
    <courses-courses-edit-occurrence-automated-planning-group-footer
        planning-group="vm.planningGroup"
        form="vm.form"
        tab="'general'"
        context="vm.context"
    />
    `
})
export default class {
    constructor ($scope, $translate, PrivilegeService, TokenService, SiteService, AutomatedPlanningGroupResource,
                 FormFactory, AUTOMATED_PLANNING_GROUP_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM,
                 AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM, AUTOMATED_PLANNING_GROUP_MAX_WORKING_SINCE_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.SiteService = SiteService;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_MAX_WORKING_SINCE_ENUM = AUTOMATED_PLANNING_GROUP_MAX_WORKING_SINCE_ENUM;

        // both belong to the component, not to the group it is showing, so they are set here and never
        // in $onInit(), which runs again on every planning-group:update
        this.saveErrorsShown = false;
        this.eventListenersInitialised = false;

        this.form = FormFactory.createFromResource(
            this.planningGroup,
            { expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,targetRulesets.conditions' }
        );
    }

    $onInit () {
        this.form.model.targets = this.planningGroup.planningGroupTargetsWithValue;

        // Sync siteId from planningGroup to form model (bindings may not be ready in constructor)
        // Convert to number since ng-options uses site.id (number) as values
        if (Array.isArray(this.planningGroup.siteIds)) {
            this.form.model.siteIds = this.planningGroup.siteIds.map(Number);
        }
        else if (this.planningGroup.siteId !== undefined && this.planningGroup.siteId !== null) {
            this.form.model.siteIds = [Number(this.planningGroup.siteId)];
        }
        else {
            this.form.model.siteIds = [];
        }

        this.initReadOnlyFields();
        this.initIntervalType();
        this.initAssignmentTimeBeforeDeadlineType();
        this.initRecurringTrainingDeadlineTypeType();
        this.initSiteSelect();
        this.initSiteMultiFilter();
        this.initVersionSelect();
        this.initTooltips();
        this.initEventListeners();
        this.initExcludeExternalSites();

        this._buildIntervalTypeOptions();
        this.intervalTypeObj = this._findIntervalTypeOption(this.form.model.intervalType);
        this.assignmentBeforeTypeObj = this._findIntervalTypeOption(this.form.model.assignmentTimeBeforeDeadlineType);
        this.recurringTypeObj = this._findIntervalTypeOption(this.form.model.recurringTrainingDeadlineType);

        this.showSaveErrors();
    }

    /**
     * Errors a save was refused with on another tab, shown here where the sites and the people of the
     * group can actually be changed. Applied once: $onInit() runs again after every successful save, and
     * a message about a state the save just replaced must not come back with it.
     *
     * The flag is what makes "once" hold. saveErrors is a one way binding, and AngularJS re-assigns it
     * from the parent on the first digest after the component is linked, so clearing the local copy is
     * undone before the next $onInit() reads it - the state parameter behind it lives as long as the
     * tab does. Only a new component, i.e. a new refusal redirecting here, shows a message again.
     */
    showSaveErrors () {
        if (this.saveErrorsShown || !this.saveErrors) {
            return;
        }

        this.saveErrorsShown = true;
        this.form.errors = angular.copy(this.saveErrors);

        // $onInit() runs again on every planning-group:update, i.e. right after a save that succeeded,
        // and form-wrapper shows "Changes saved" while form.saved is set: a refusal carried here must
        // never arrive next to it
        this.form.saved = false;
    }

    initReadOnlyFields () {
        this.isReadOnly = !this.PrivilegeService.canManageAutomatedPlanningGroups();

        this.isAssignmentTimeBeforeDeadlineReadOnly =
        this.isRecurringTrainingDeadlineReadOnly = !(
            this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.NOT_STARTED
            || this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED
            || this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STOPPED
        ) || !this.PrivilegeService.canManageAutomatedPlanningGroups();
    }

    initExcludeExternalSites () {
        if (this.form.model.excludeExternalSites) {
            this.form.model.excludeExternalSites = Boolean(this.form.model.excludeExternalSites);
        }
        if (!this.form.model.id && !this.hasSelectedSiteIds() && this.TokenService.isTrainingCompany()) {
            this.form.model.excludeExternalSites = true;
        }
    }

    initIntervalType () {
        if (!this.form.model.intervalType) {
            this.form.model.intervalType = this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM.KEYS.DAY;
        }
    }

    initAssignmentTimeBeforeDeadlineType () {
        if (!this.form.model.assignmentTimeBeforeDeadlineType) {
            this.form.model.assignmentTimeBeforeDeadlineType = this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM.KEYS.DAY;
        }
    }

    initRecurringTrainingDeadlineTypeType () {
        if (!this.form.model.recurringTrainingDeadlineType) {
            this.form.model.recurringTrainingDeadlineType = this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM.KEYS.DAY;
        }
    }

    initVersionSelect () {
        this.oldVersionId = this.form.model.courseVersionId ? this.form.model.courseVersionId : null;

        // if only 1 version option, preselect it
        if (!this.oldVersionId && this.courseVersions.length === 1) {
            this.form.model.courseVersionId = this.courseVersions[0].id;
        }
    }

    initSiteSelect () {
        const accessToAllSites = this.SiteService.hasAccessToAllSites(this.sites);
        const hasSiteIds = this.hasSelectedSiteIds();
        this.disableSiteSelect = this.form.model.id && !accessToAllSites && !hasSiteIds;

        this.oldSiteIds = hasSiteIds ? [...this.form.model.siteIds] : [];

        // set default site id if add scenario and there is only one site option
        if (!hasSiteIds && !this.form.model.id && this.sites.length === 1) {
            this.form.model.siteIds = [this.sites[0].id];
        }
    }

    initSiteMultiFilter () {
        // an empty siteIds list means the group covers every site, the option makes that an explicit
        // choice instead of an empty selection that reads as "nothing picked yet"
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };

        const siteOptions = this.getSiteOptions();

        this.siteMultiFilter = {
            options: siteOptions,
            models: this.getSelectedSiteOptions(siteOptions),
            settings: {
                checkBoxes: true,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 5,
                smartButtonTextConverter: (itemText) => itemText
            },
            events: {
                onItemSelect: this.getSiteItemCallback(),
                onItemDeselect: this.getSiteItemCallback()
            },
            translations: {
                buttonDefaultText: this.$translate.instant('filter.Select')
            }
        };
    }

    /**
     * All sites can only be selected on its own
     * - selecting it unchecks every individual site
     * - selecting an individual site unchecks it
     * @returns {Function}
     */
    getSiteItemCallback () {
        return item => {
            if (item.value === null) {
                this.siteMultiFilter.models = [this.allSitesOption];
            }
            else {
                this.siteMultiFilter.models = this.siteMultiFilter.models.filter(
                    model => model.value !== null
                );
            }
            this.onSiteChange();
        };
    }

    getSiteOptions () {
        const siteOptions = [];

        // only offer all sites to someone who is allowed to leave the group unrestricted, or when the
        // group already is, otherwise they would build a selection the backend rejects
        if (this.showAllSites()) {
            siteOptions.push(this.allSitesOption);
        }

        this.sites.forEach(site => siteOptions.push({
            value: site.id,
            label: site.name
        }));

        return siteOptions;
    }

    getSelectedSiteOptions (siteOptions) {
        const selectedSiteIds = this.form.model.siteIds || [];

        if (selectedSiteIds.length) {
            return siteOptions.filter(option => selectedSiteIds.indexOf(option.value) !== -1);
        }

        return this.showAllSites() ? [this.allSitesOption] : [];
    }

    showAllSites () {
        // someone without access to every site may not build an unrestricted group, they only get the
        // option so that an existing all sites group stays readable to them
        return this.SiteService.hasAccessToAllSites(this.sites)
            || (Boolean(this.form.model.id) && !this.hasSelectedSiteIds());
    }

    hasSelectedSiteIds () {
        return Array.isArray(this.form.model.siteIds) && this.form.model.siteIds.length > 0;
    }

    isAllSitesSelected () {
        return this.siteMultiFilter.models.some(model => model.value === null);
    }

    initTooltips () {
        this.tooltipTexts = {
            name: this.$translate.instant('planningGroup.Name tooltip'),
            assignmentTimeBeforeDeadline: this.$translate.instant('planningGroup.assignmentTimeBeforeDeadlineHelperText'),
            recurringTrainingDeadline: this.$translate.instant('planningGroup.recurringTrainingDeadlineHelperText')
        };
    }

    /**
     * The planning-group:update handler re-runs $onInit(), which comes back here, so registering
     * without this guard leaves one more listener behind after every save: two, then four, then eight
     * handlers all re-initialising the same step for a single update.
     */
    initEventListeners () {
        if (this.eventListenersInitialised) {
            return;
        }

        this.eventListenersInitialised = true;

        this.$scope.$on('planning-group:update', (event, updatedGroup) => {
            this.planningGroup = updatedGroup;
            this.$onInit();
        });

        this.$scope.$on('planning-group:restore-sites', () => this.restoreSiteSelection());
    }

    /**
     * The site confirmation is answered on save, by which point the select has already applied the
     * change. Declining it cancels the save, so the selection has to go back to what is stored or the
     * group keeps showing sites it never lost and only a page reload tells the truth.
     */
    restoreSiteSelection () {
        this.form.model.siteIds = Array.isArray(this.planningGroup.siteIds)
            ? this.planningGroup.siteIds.map(Number)
            : [];
        this.form.model.excludeExternalSites = this.planningGroup.excludeExternalSites;

        this.initSiteSelect();
        this.initSiteMultiFilter();
    }

    onSiteChange () {
        this.form.cleanErrors();

        // the all sites option is a UI only value, the backend reads an empty list as every site
        this.form.model.siteIds = this.siteMultiFilter.models
            .filter(option => option.value !== null)
            .map(option => option.value)
        ;

        this.form.model.excludeExternalSites = !this.hasSelectedSiteIds()
            && this.TokenService.isTrainingCompany();
    }

    _buildIntervalTypeOptions () {
        const labels = this.AUTOMATED_PLANNING_GROUP_INTERVAL_TYPE_ENUM.LABELS;
        this.intervalTypeOptions = Object.keys(labels).map(k => ({
            key: String(k),
            label: labels[k]
        }));
    }

    _findIntervalTypeOption (val) {
        let key = null;

        if (val === 0 || val === '0') {
            key = '0';
        }
        else if (val !== null && val !== undefined) {
            key = String(val);
        }

        return this.intervalTypeOptions.find(o => o.key === key) || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/steps/general/index.js